/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./deleteDraft.defs.js";
export { main as default } from "./deleteDraft.defs.js";
